import React from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';

import { AssetType } from 'entities/assets/model';
import { AssetsDocument } from 'features/asset/add-assets-modal/graphql/queries.gen';
import { GetAssetsDocument } from 'pages/art-catalog/ui/ArtCatalogTable/queries.gen';
import { ButtonType, trackAssetDeleted } from 'shared/analytics';
import { useAppToast } from 'shared/hooks/toast';
import { TrashBinIcon } from 'shared/icons';
import { EntityDeletionAlert } from 'shared/ui/entity-deletion-alert';

import { useDeleteBackgroundMutation } from './queries.gen';

interface DeleteBackgroundButtonProps {
	id: string;
	onCompleted: () => void;
}

export const DeleteBackgroundButton: React.FC<DeleteBackgroundButtonProps> = ({
	id,
	onCompleted,
}) => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const toast = useAppToast();
	const [deleteBackground, { loading }] = useDeleteBackgroundMutation({
		variables: { id },
		onCompleted: (data) => {
			toast({ title: 'Background deleted successfully', status: 'success' });
			onCompleted();
			trackAssetDeleted({
				type: AssetType.BACKGROUND,
				filename: data.deleteBackground?.filename as string,
				link: data.deleteBackground?.link as string,
			});
		},
		onError: () =>
			toast({ title: 'Background was not deleted', status: 'error' }),
		refetchQueries: [AssetsDocument, GetAssetsDocument],
	});

	return (
		<>
			<Button
				disabled={loading}
				onClick={onOpen}
				leftIcon={<TrashBinIcon w={6} h={6} />}
			>
				Delete Background
			</Button>
			{isOpen && (
				<EntityDeletionAlert
					isOpen={isOpen}
					onClose={onClose}
					onSubmit={deleteBackground}
					buttonName={ButtonType.DELETE_BACKGROUND}
					title="Background Deletion"
					description="If you delete this background, it can't be restored. Are you sure you want to continue?"
				/>
			)}
		</>
	);
};
